import { SET_ITEM_COUNT, SET_OPTED_IN, SET_IS_AVAILABLE } from "./constants";

export const getLoyaltyStatus = state => state.loyalty;

const initialState = {
  itemCount: null,
  optedIn: false,
  isAvailable: false
};

export const reduce = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_OPTED_IN: {
      return {
        ...state,
        optedIn: payload.optedIn
      };
    }
    case SET_IS_AVAILABLE: {
      return {
        ...state,
        isAvailable: payload.isAvailable
      };
    }
    case SET_ITEM_COUNT: {
      return {
        ...state,
        itemCount: payload.itemCount
      };
    }
    default:
      return state;
  }
};
